







import { Spell } from '@/types'
import Vue, { PropType } from 'vue'
export default Vue.extend({
  name: 'SpellBookEntry',
  props: {
    spell: {
      type: Object as PropType<Spell>,
      required: true,
    },
  },
  methods: {
    removeEntry () {
      this.$store.commit('removeFromSpellBook', this.spell.id)
    },
  },
})
